module.exports = __webpack_public_path__ + "static/media/logo-euro.a064e736.svg";